import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ModuleSharedModule } from '../../modules/module-shared.module';
import { ZoomImageFullScreenPage } from './zoom-image-fullscreen.page';

@NgModule({
  declarations: [ZoomImageFullScreenPage],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleSharedModule,
  ],
  exports: [ZoomImageFullScreenPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ZoomImageFullScreenPageModule { }
